import React from 'react';
// @ts-ignore
import { Button, Loader, HorizontalRule } from 'arag-ui-lib';
import SurveyFormWrapper from '../surveyForm/surveyFormWrapper';
import generalStyle from '../../assets/styles/generalStyle.module.scss';
import codes from '../../utils/constants/codes';
import { useTranslation } from 'react-i18next';

type Props = {
    surveyData: any;
    surveysHandler: (item: any) => void;
    activeView: any;
    questions: any;
    onSubmitSurvey: (values: any) => void;
    posting: boolean;
    heading?: string;
};

const SurveyList = (props: any): any => {
    const { surveyData, surveysHandler } = props;
    const { t } = useTranslation();
    return (
        <>
            <div className={'row'}>
                <div className={'col-sm-12'}>
                    <p>{codes.surveyTitle}</p>
                    <HorizontalRule variant="pale" />
                </div>
            </div>
            <div>
                {surveyData?.surveyTypes?.map((item: any, index: number) => {
                    return (
                        <div
                            className={`row ${generalStyle['content-marginTop-marginBottom']}`}
                            key={index}
                        >
                            <div className={'col-sm-12'}>
                                <p>{item.surveyTypeDescription}</p>
                                <Button
                                    variant="quaternary"
                                    label={`${t('viewSurvey', { surveyType: item?.surveyTypeName && item.surveyTypeName !== codes.surveyRejectedType ? item?.surveyTypeName : '' })}`}
                                    arrowDirection="left"
                                    onClick={() => surveysHandler(item)}
                                />
                            </div>
                        </div>
                    );
                })}
            </div>
        </>
    );
};
const MultipleSurvey = (props: Props): JSX.Element => {
    const {
        surveyData,
        surveysHandler,
        activeView,
        questions,
        onSubmitSurvey,
        posting,
    } = props;
    return (
        <div>
            {!activeView && (
                <SurveyList
                    surveyData={surveyData}
                    surveysHandler={surveysHandler}
                />
            )}
            {activeView && (
                <SurveyFormWrapper
                    questions={questions}
                    heading={activeView?.title}
                    onSubmitSurvey={onSubmitSurvey}
                    posting={posting}
                />
            )}
        </div>
    );
};

export default MultipleSurvey;
